// The Arcade action set. The slice binds exactly these six across keyboard,
// touch, and gamepad. Every input source resolves to this vocabulary, and the
// Actor only ever reads Actions — never a raw key or button — so re-binding or
// adding a source never touches gameplay code.
//
// `up` and `down` walk the DEPTH axis of the belt, into and out of the street.
// They are not jump. In a belt-scroll the up key cannot be jump, because up is
// where half the playfield is — which is why jump moves to its own button.

export const ACTIONS = ['left', 'right', 'up', 'down', 'jump', 'attack'] as const;
export type Action = (typeof ACTIONS)[number];

/** Per-action edge-aware state, recomputed once per frame by the ControlMap. */
export interface ActionState {
  /** Held this frame (any bound source down). */
  down: boolean;
  /** Went down THIS frame (rising edge) — for jump / attack triggers. */
  pressed: boolean;
  /** Went up this frame (falling edge) — for variable-height jump cutoff. */
  released: boolean;
}

export function emptyActionState(): ActionState {
  return { down: false, pressed: false, released: false };
}
